/** FAQ anchor for browser / PWA push troubleshooting. */
export const PUSH_NOTIFICATIONS_HELP_HREF = "/faq#notifications-browser";

export function pushPermissionDeniedMessage(): string {
  return "Notifications are blocked for this site. Enable them in your browser or device settings.";
}

export function pushPermissionHelpHint(): string {
  return "See our FAQ for step-by-step help on iPhone, Android, and desktop browsers.";
}
